import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-email-content',
  templateUrl: './email-content.component.html',
  styleUrls: ['./email-content.component.scss']
})
export class EmailContentComponent  {
  @Input() form!: FormGroup;
  @Input() controlName!: string;

  isHtmlType = false;


}
